import {Text} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'

const CartOrderProductCount = ({totalItems, textStyle}) => {
    return (
        <Text textStyle={textStyle}>
            <FormattedMessage
                defaultMessage="{itemCount, plural, =0 {0 products} one {# product} other {# products}}"
                values={{itemCount: totalItems}}
                id="cart_title.title.cart_num_of_items"
            />
        </Text>
    )
}

export default CartOrderProductCount

CartOrderProductCount.propTypes = {
    totalItems: PropTypes.number,
    textStyle: PropTypes.string
}
